module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 31
// module chunks = 0 1